export const getIssueKey = (type: number) => {
  switch (type) {
    case 0:
      return "CHKSDD";
    case 1:
    case 6:
      return "DIGSDD";
    case 3:
    case 8:
      return "TXTSDD";
    default:
      return "CHRSDD";
  }
};

export const getIssueInputType = (type: number) => {
  switch (type) {
    case 0:
      return "checkbox";
    case 1:
    case 6:
      return "number";
    case 3:
      return "textarea";
    case 4:
      return "select";
    case 7:
      return "date";
    case 8:
      return "dictionary";
    default:
      return "text";
  }
};
